import { makeStyles, createStyles } from '@material-ui/core/styles';

export default makeStyles(({ palette, spacing, shape, typography }) => createStyles({
    card: {
        borderRadius: "24px",
        background: palette.common.white,
        padding: spacing(4)
    }
}));
